import { render, staticRenderFns } from "./VistaDetalle.vue?vue&type=template&id=214e4d49&scoped=true&"
import script from "./VistaDetalle.vue?vue&type=script&lang=js&"
export * from "./VistaDetalle.vue?vue&type=script&lang=js&"
import style0 from "./VistaDetalle.vue?vue&type=style&index=0&id=214e4d49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214e4d49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VNavigationDrawer,VRow})
